import React from 'react';
import PropTypes from 'prop-types';
import './SectionHeader.css';

/**
 * SectionHeader - Ein wiederverwendbarer Accordion-Header für das Export-Modal.
 * 
 * @param {Object} props
 * @param {string} props.id - Die ID der Sektion (für Toggle-Logic)
 * @param {string} props.title - Der Anzeigename der Sektion
 * @param {string} props.icon - Emoji oder Icon-Klasse
 * @param {boolean} props.isExpanded - Ob die Sektion aktuell offen ist
 * @param {Function} props.onToggle - Callback beim Klick
 * @param {React.ReactNode} props.children - Zusätzliche Elemente (z.B. Badges)
 */
const SectionHeader = ({ id, title, icon, isExpanded, onToggle, children }) => {
    return (
        <div 
            className={`export-section-header ${isExpanded ? 'active' : ''}`}
            onClick={() => onToggle(id)}
        >
            <div className="export-section-title">
                <span className="export-section-icon">{icon}</span>
                {title}
                {children}
            </div>
            <div className={`export-section-chevron ${isExpanded ? 'open' : ''}`}>
                ▶
            </div>
        </div>
    );
};

SectionHeader.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    icon: PropTypes.string,
    isExpanded: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
    children: PropTypes.node
};

export default SectionHeader;
